import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  item: NewsItem;
  layout?: "vertical" | "horizontal";
}

export default function NewsCard({ item, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
      >
        <div className="w-28 h-20 md:w-36 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-100">
          <img src={item.cover} alt={item.title} className="w-full h-full object-cover" />
        </div>
        <div className="min-w-0 flex flex-col justify-between">
          <div>
            <span className="text-[11px] font-label text-primary-600">{item.category}</span>
            <h3 className="mt-1 text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
              {item.title}
            </h3>
          </div>
          <span className="text-[11px] text-foreground-500 mt-2">{item.date}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300"
    >
      <div className="w-full h-48 overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900 text-[11px] font-label">{item.category}</span>
          <span className="text-[11px] text-foreground-500">{item.date}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.excerpt}</p>
        <span className="mt-4 text-xs text-primary-600 flex items-center gap-1">
          阅读全文 <i className="ri-arrow-right-line" />
        </span>
      </div>
    </Link>
  );
}